import * as React from 'react'
import styled from 'styled-components'

import { Color, Size } from '../../../constants/app.constant'

interface Props {
  onClick?(e: React.MouseEvent<HTMLElement>): void
  primary?: boolean
  secondary?: boolean
  disabled?: boolean
  large?: boolean
  type?: string
  css?: string
  children: React.ReactNode
}

const getColors = (props: Props): string => {
  if (props.primary) {
    return `
      border: 1px solid ${Color.BRAND.PRIMARY};
      background: ${Color.BRAND.PRIMARY};
      color: ${Color.PALETTE_COLOR.WHITE};
    `
  } else if (props.secondary) {
    return `
      border: 1px solid ${Color.BRAND.SECONDARY};
      background: ${Color.BRAND.SECONDARY};
      color: ${Color.PALETTE_COLOR.WHITE};
    `
  } else {
    return `
      border: 1px solid ${Color.BRAND.PRIMARY};
      color: ${Color.BRAND.PRIMARY};
      background: ${Color.PALETTE_COLOR.WHITE};
    `
  }
}

const StyledButton = styled.button<Props>`
  border-radius: 50px;
  cursor: pointer;
  font-size: ${Size.FONT.MIDDLE}px;
  &:focus {
    outline: none;
  }
  padding: ${({ large }) => (large ? '16px' : '13px')};

  ${getColors};
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.3;
    pointer-events: none;
  `};
`

const Button: React.SFC<Props> = (props: any) => <StyledButton {...props} />

export default styled(Button)``



// WEBPACK FOOTER //
// ./src/components/atoms/button/button.tsx